import { render, staticRenderFns } from "./UpdateContent.vue?vue&type=template&id=6c117f1a&"
import script from "./UpdateContent.vue?vue&type=script&lang=js&"
export * from "./UpdateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports